export const options = (
  excessDepth = false,
  needToHideArray = false,
  needToShowList = false,
): Array<Record<string, string>> =>
  [
    { value: "json_object", label: "JSON Object", iconName: "object" },
    { value: "json_array", label: "JSON Array", iconName: "array" },
    { value: "text", label: "Text", iconName: "text" },
    { value: "boolean", label: "Boolean", iconName: "yes-and-no" },
    { value: "number", label: "Number", iconName: "number" },
    { value: "list", label: "List", iconName: "formatting-bullet-list" },
  ]
    .filter(
      (option) =>
        !excessDepth ||
        (excessDepth &&
          option.value !== "json_array" &&
          option.value !== "json_object"),
    )
    .filter((option) => !needToHideArray || option.value !== "json_array")
    .filter(
      (option) =>
        option.value !== "list" || (option.value === "list" && needToShowList),
    );
